import Vue from 'vue'
import Vuex from 'vuex'
import router from './router'
import axios from 'axios';
import {autoLogoutModule} from "./store/auto_logout.js";

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        autoLogoutModule: autoLogoutModule
    },
    state: {
        token: null,
        tokenId: null,
        user: null,
        status: null,
        error: null,
        sysState: true,
    },
    getters: {
        isLoggedIn: state => !!state.user,
        sysState: state => state.sysState,
        role: state => state.user.user_role.id,
        roleRef: state => state.user.user_role.role_ref,
        niMerchantAccess: state => state.user.ni_pos_merchant_id,
    },
    mutations: {
        authUser(state, data) {
            state.token = data.token;
            state.tokenId = data.tokenId;
            state.user = data.user;
            state.status = data.status;
            state.error = '';
        },
        logout(state) {
            state.token = '';
            state.tokenId = '';
            state.user = '';
            state.status = '';
            state.error = '';
        },
        loginError(state, data) {
            state.error = data.error;
        },
        stateSwitch(state, data) {
            state.sysState = data.sysState;
        },
    },
    actions: {
        login({ dispatch, commit }, user) {
            
            const url = process.env.VUE_APP_BASE_URL || 'https://controlapi-v2.totalprocessing.com/'

            axios({
                url:'sanctum/csrf-cookie',
                baseURL: url,
                method: 'GET'
            }).then(response => {
                
                axios({
                method: 'POST',
                url: 'login',
                baseURL: url,
                data: user,
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }},
                withCredentials: true,
                })
                .then(response => {
                    
                    axios({
                        method: 'get',
                        url: 'get-user-oauth',
                        config: {}
                        })
                        .then(response => {
                            if(response.data) {
                                localStorage.setItem('user', JSON.stringify(response.data));

                                commit('authUser', {
                                    user: response.data,
                                    status: 'success'
                                });

                                // initialise session expiration timers
                                dispatch('refreshSessionTimers').autoLogoutModule;
                                
                                router.push('/');
                            }
                            else {
                                router.push('/login');
                            }

                        })
                        .catch(e => {
                            this.errors.push(e);
                            return e;
                        })   
                    router.push('/');
                })
                .catch(e => {
                    commit('loginError', {
                        error: e.response.data.error
                    })
                })
            });
        },
        async autoLogin({commit}) {      
            try {
                const res = await axios({
                method: 'get',
                url: 'get-user-oauth',
                config: {}
                })
                .then(response => {
                    if(response.data) {
                        commit('authUser', {
                            user: response.data,
                            status: 'success'
                        });
                        return response;
                    }
                    else {
                        return false;
                    }
                    
                })
                .catch(e => {
                    this.errors.push(e);
                    return e;
                })
                return res;
            }
            catch(e) {
                console.log(e);
                return e;
            }
        },
        logout({commit}) {
            const url = process.env.VUE_APP_BASE_URL
            
            axios({
            method: 'post',
            url: 'logout',
            baseURL: url,
            config: { headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }}
            })
            .then(response => {
                commit('authUser', {
                    user: null,
                    status: null
                });
                console.log(response);
                localStorage.clear();
                sessionStorage.clear();

                router.push('/login');
                location.reload();
            })
            .catch(e => {
                this.errors.push(e)
            })
        },
        async clientAccess({commit}, e) {
            return await axios({
            method: 'post',
            url: 'get-client-access-client',
            data: { merchants: e.merchants, id: e.id },
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                return response.data;
            })
            .catch(e => {
                this.errors.push(e)
            })
        },
        switchPress({commit}, e) {
            commit('stateSwitch', {
                sysState: e
            });
        }
    },
})